import NOTIFICATIONS from './notifications';

const NOTIFICATION_TYPES = Object.values(NOTIFICATIONS.types);

export default NOTIFICATION_TYPES;
